module.exports = __webpack_public_path__ + "static/img/20200611124132.6b226d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20200611124132.jpg
// module id = uj79
// module chunks = 2